<!-- Navbar -->
<header class="app-header navbar">
  <ul class="nav navbar-nav d-md-down-none">
    <li class="nav-item" (click)="goBack()">
      <a class="nav-link" href="javascript:void(0)">
        <span class=""><i class="fa s-icon-back fa-2x text-white"></i></span>
      </a>
    </li>
    <li class="nav-item page-title">
      <span class="d-flex align-items-baseline"></span>
    </li>
    <li class="nav-item">
      <a class="nav-link navbar-toggler sidebar-toggler" href="javascript:void(0)" (click)="toggleSidebar()">
        <span class=""><i class="fa s-icon-menu fa-2x text-white"></i></span>
      </a>
    </li>
  </ul>
</header>

<div class="app-body">
  <div style="display: flex; width: 100%;">
    <main class="main">
      <div class="container-fluid">
        @if (navigationUnavailable) {
          <div class="alert alert-warning" role="status">
            一部のメニューを取得できませんでした。表示されている機能は引き続き利用できます。
            <button type="button" class="btn btn-blue text-white" (click)="loadNavigation()" [disabled]="navigationLoading">メニューを再取得</button>
          </div>
        }
        <router-outlet></router-outlet>
      </div>
    </main>
  </div>

  <!-- Sidebar -->
  <div class="sidebar">
    <nav class="sidebar-nav">
      <ul class="nav">
        <li class="nav-item nav-close">
          <a class="navbar-toggler sidebar-toggler" href="javascript:void(0)" (click)="closeSidebar()">
            <span class="navbar-toggler-icon"><i class="fa s-icon-menuClose fa-2x text-white"></i></span>
          </a>
        </li>
        @if (isConfiguredQR) {
          <li class="nav-item" (click)="closeSidebarAfterNavigation()">
            <a class="nav-link sidebar-toggler d-flex align-items-center" style="gap:1rem"
               routerLink="/inout-qr" routerLinkActive="active">
              <i><span class="material-symbols-outlined align-bottom font-4xl">qr_code</span></i>
              <span>&nbsp;入退館QR</span>
            </a>
          </li>
        }
        <li class="nav-item" (click)="closeSidebarAfterNavigation()">
          <a class="nav-link sidebar-toggler d-flex align-items-center" style="gap:1rem"
             routerLink="/member" routerLinkActive="active">
            <i><span class="material-symbols-outlined align-bottom font-4xl">person</span></i>
            <span>&nbsp;会員情報</span>
          </a>
        </li>
        <li class="nav-item" (click)="closeSidebarAfterNavigation()">
          <a class="nav-link sidebar-toggler d-flex align-items-center" style="gap:1rem"
             routerLink="/transaction" routerLinkActive="active">
            <i><span class="material-symbols-outlined align-bottom font-4xl">currency_yen</span></i>
            <span>&nbsp;支払情報</span>
          </a>
        </li>
        <li class="nav-item" (click)="closeSidebarAfterNavigation()">
          <a class="nav-link sidebar-toggler d-flex align-items-center" style="gap:1rem"
             routerLink="/inout" routerLinkActive="active">
            <i><span class="material-symbols-outlined align-bottom font-4xl">footprint</span></i>
            <span>&nbsp;入退館履歴</span>
          </a>
        </li>
        <li class="nav-item" (click)="closeSidebarAfterNavigation()">
          <a class="nav-link sidebar-toggler d-flex align-items-center" style="gap:1rem"
             routerLink="/notification" routerLinkActive="active">
            <i><span class="material-symbols-outlined align-bottom font-4xl">inventory</span></i>
            <span>&nbsp;諸届</span>
          </a>
        </li>
        @if (isCounselable) {
          <li class="nav-item" (click)="closeSidebarAfterNavigation()">
            <a class="nav-link sidebar-toggler d-flex align-items-center" style="gap:1rem"
               routerLink="/personal" routerLinkActive="active">
              <i><span class="material-symbols-outlined align-bottom font-4xl">contract</span></i>
              <span>&nbsp;パーソナルログ</span>
            </a>
          </li>
        }
        @if (reservationGlobalFlag) {
          <li class="nav-item" (click)="closeSidebarAfterNavigation()">
            <a class="nav-link sidebar-toggler d-flex align-items-center" style="gap:1rem"
               routerLink="/pt-reservation" routerLinkActive="active">
              <i><span class="material-symbols-outlined align-bottom font-4xl">calendar_month</span></i>
              <span>&nbsp;PT予約</span>
            </a>
          </li>
        }
        <li class="nav-item p-1 pl-0">
          <a class="nav-link pt-3 pb-3 pl-5 bg-white text-blue d-flex align-items-center sidebar-logout"
             style="gap:1rem" href="javascript:void(0)" (click)="logout(); $event.preventDefault()" title="ログアウト">
            <i><span class="material-symbols-outlined text-blue align-bottom font-4xl">logout</span></i>
            <span>&nbsp;ログアウト</span>
          </a>
        </li>
      </ul>
    </nav>
  </div>
</div>

<!-- Footer -->
<footer class="app-footer">
  <span class="ml-auto">Powered by &copy; <a href="//smartfit100.com">Smartfit 100</a></span>
</footer>
